import { distance_latLong_toKM, featureFlagKeys, getCookie, getFeatureFlags, getHash, getTrip_cachedForm, titleCase, titleCase_withStates } from "../../util/general_util";
import { Campground_Data, Trip_Cluster_v2, Trip_leg_v2, Trip_v2 } from "../../util/tripPlanner_types";
import { fetch_genieMatches, lock_stop } from "../api_utils";
import { display_stop_popout, hide_map_loadingIcon, show_map_loadingIcon } from "../ui_utils";

export async function check_interaction_counter ():Promise<void> {
	let interactionCap:number|"inf";
	let interactionCapSettings_str:string|null = getCookie("tp-int-cap");
	let interactionCapSettings:any;

	try {
		interactionCapSettings = JSON.parse(interactionCapSettings_str);
	} catch (e) {
		interactionCapSettings = null;
	};

	if (!interactionCapSettings || interactionCapSettings.length == 0) {
		if (!window.featureFlags || !window.featureFlags.freemiumAccess) {
			window.featureFlags = await getFeatureFlags(featureFlagKeys);
			interactionCapSettings = window.featureFlags.freemiumAccess.interactionCap;
		};
	};

	let subLevel:string;
    switch(parseInt(window.GAsubLevel)) {
        case 2:
            subLevel = "subscriber";
            break;
        case 1:
            subLevel = "subscriber";
            break;
        case 0:
            subLevel = "member";
            break;
        default:
            subLevel = "anonymous";
            break;
    };

	if (!interactionCapSettings) {
		interactionCap = Infinity;
	} else {
		interactionCap = interactionCapSettings[subLevel];
	};
	if (interactionCap == "inf") {
		interactionCap = Infinity;
	};

	const interaction_count = get_interaction_counter()

	if (interaction_count > interactionCap) {
		$("#interactionCap_blockInteraction").modal("show");

		try{
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({'event': 'interaction-cap-reached'});
        } catch (error){
            console.error(error.message)
        }
	};
};

export async function inc_interaction_counter ():Promise<void> {
	let count = parseInt(localStorage.getItem("interactionCounter") || "0");
	count++;
	localStorage.setItem("interactionCounter",count.toString());

	check_interaction_counter();
};

export function get_interaction_counter ():number {
	return parseInt(localStorage.getItem("interactionCounter") || "0");
};

export function reset_interaction_counter ():void {
	localStorage.setItem("interactionCounter","0");
};

export async function handle_auto_lock(stopData:{stop:Trip_Cluster_v2,legIndex:number,stopIndex:number}) {
	show_map_loadingIcon("Locking Stop");
	const directions = window.tripPlannerCurrentTrip.directions
	const newTrip = await lock_stop(
		window.tripPlannerCurrentTrip,
		stopData.legIndex,
		stopData.stopIndex,
		stopData.stop.stopID
	).catch(e => {
		if (e.message == "max-stops") {
			const msg = "Start your free trial to add more stops";
			if (Number.isNaN(parseInt(window.GAsubLevel))) {
				//not signed in
				$("#signUp_cardedTrialModal").find("[signUpMsg]").html(msg);
				$("#signUp_cardedTrialModal").modal("show");

			} else {
				$("#freemium-carded-trial").find("[signUpMsg]").html(msg);
				$("#freemium-carded-trial").modal("show");
			};
			try{
				//Google Analytics signup tracking (see how many times modal has opened)
				window.dataLayer = window.dataLayer || [];
				window.dataLayer.push({'event': 'showMemberSignup', 'showMemberSignupParameters':{'carded':'true', 'message' : msg, 'page':window.location.href}});
			} catch (error){
				console.error(error.message)
			};
		} else {
			console.error(e);
		};
		hide_map_loadingIcon();
		console.error(e);

		return null;
	});
	hide_map_loadingIcon();

	if (typeof newTrip == "undefined") {
		return null;
	}

	newTrip.directions = directions;
	window.tripPlannerCurrentTrip = newTrip;
	stopData = get_stop_from_stopID(stopData.stop.stopID, window.tripPlannerCurrentTrip);

	document.dispatchEvent(new CustomEvent("trip.updated",{detail:{zoom:false}}));

	const stopPopout:JQuery<HTMLElement> = $("#stopPopout");
	if (stopPopout.attr("stopID") == stopData.stop.stopID && stopPopout.is(":visible")) {
		display_stop_popout(stopData.stop.stopID, false, false);
		stopPopout.find("[stopAddedToast]").removeClass("d-none");
		setTimeout(() => {
			stopPopout.find("[stopAddedToast]").addClass("d-none");
		},5000);

	};

	inc_interaction_counter();

	return stopData;
};

export function savedTrip_noChanges(trip:Trip_v2) {
	if (trip == null) {
		return false;
	};
	let tripState: string = getHash(JSON.stringify(getTrip_cachedForm(trip)));

	return tripState == window.initTripState;
};

export function getClosestStopIndices(trip: Trip_v2, loc: { latitude: number, longitude: number }) {
	let minDist = Infinity;
	let closestStopsIndices: Array<{ legIndex: number, stopIndex: number }>;
	let allStops: Array<{ legIndex: number, stopIndex: number, loc: { latitude: number, longitude: number } }> = [];
	let i: number, j: number;
	for (i = 0; i < trip.legs.length; i++) {
		for (j = 0; j < trip.legs[i].clusters.length; j++) {
			allStops.push({
				legIndex: i,
				stopIndex: j,
				loc: trip.legs[i].clusters[j].coords
			});
		};
	};

	let dist1: number, dist2: number;
	for (i = 0; i < allStops.length - 1; i += 2) {
		dist1 = distance_latLong_toKM(loc, allStops[i].loc);
		dist2 = distance_latLong_toKM(loc, allStops[i + 1].loc);
		if (dist1 + dist2 < minDist) {
			minDist = dist1 + dist2;
			closestStopsIndices = [
				{ legIndex: allStops[i].legIndex, stopIndex: allStops[i].stopIndex },
				{ legIndex: allStops[i + 1].legIndex, stopIndex: allStops[i + 1].stopIndex }
			];
		};
	};

	return closestStopsIndices
};

export function get_selected_legs_for_recalc():Array<{legs:number[],dist:number}> {
	const settings:Array<{legs:number[],dist:number}> = [];
	$("[per-leg-mile-setting]").each(function(idx,el) {
		const dist = parseInt($(el).find("[per-leg-mile-setting-input]").val().toString());
		if (Number.isNaN(dist)) return;
		settings.push({
			legs: $(el).find("[perLeg_routeOptions_selectedLegs]").children().map(function(idx,el) {return parseInt(el.getAttribute("leg"))}).toArray(),
			dist: dist
		});
	});
	return settings.filter((setting) => setting.legs.length > 0)
};

export function get_stop_from_indices_and_id(legIndex:number, stopIndex:number, stopID:string, trip:Trip_v2) {
	if (Number.isNaN(legIndex) || Number.isNaN(stopIndex) || stopID == undefined) return null;
	if (legIndex >= window.tripPlannerCurrentTrip.legs.length) return null;
    const leg:Trip_leg_v2 = window.tripPlannerCurrentTrip.legs[legIndex];
    if (stopIndex >= leg.clusters.length) return null;
    let stop:Trip_Cluster_v2|null = leg.clusters[stopIndex];

	if (stop.stopID == stopID) return stop;

	for (let i:number = 0; i < trip.legs.length; i++) {
		for (let j:number = 0; j < trip.legs[i].clusters.length; j++) {
			if (trip.legs[i].clusters[j].stopID == stopID) return trip.legs[i].clusters[j];
		};
	};
	return null;
};

export function get_stop_from_stopID(stopID:string, trip:Trip_v2):{stop:Trip_Cluster_v2,legIndex:number,stopIndex:number}|null {
	if (trip == undefined || trip.legs == undefined) return null;
	for (let i:number = 0; i < trip.legs.length; i++) {
		for (let j:number = 0; j < trip.legs[i].clusters.length; j++) {
			if (trip.legs[i].clusters[j].stopID == stopID) {
				return {
					stop: trip.legs[i].clusters[j],
					legIndex: i,
					stopIndex: j
				};
			};
		};
	};
	return null;
};

function reverseArr(arr: Array<any>): Array<any> {
	let reversedArr: Array<any> = [];
	for (let i: number = arr.length - 1; i >= 0; i--) {
		reversedArr.push(arr[i]);
	};

	return reversedArr;
};

function reverseLockedArr(lockedArr: Array<number>, len: number): Array<number> {
	let reversedLockedArr: Array<number> = [];

	for (let i: number = 0; i < lockedArr.length; i++) {
		reversedLockedArr.push((len - 1) - lockedArr[i]);
	};

	return reversedLockedArr;
};

export function reverseTrip(trip:Trip_v2):Trip_v2 {
	const new_trip: Trip_v2 = {
		name: trip.name,
		desc: trip.desc,
		tripID: trip.tripID,
		startDate: trip.startDate,
		filters: trip.filters,
		queries: reverseArr(trip.queries),
		autoFillData: reverseArr(trip.autoFillData),
		lockedLegs: reverseLockedArr(trip.lockedLegs, trip.legs.length),
		legs: [],
		stopListHTML: "",
		directions: null
	};

	if ("geo_queries" in trip) {
		if (trip.geo_queries != undefined) {
			new_trip["geo_queries"] = reverseArr(trip.geo_queries);
		};
	};

	let lastCluster_ofprevLeg: Trip_Cluster_v2 | undefined = undefined;

	for (let i: number = trip.legs.length - 1; i >= 0; i--) {
		if (lastCluster_ofprevLeg !== undefined) {
			trip.legs[i].clusters.push(lastCluster_ofprevLeg);
		};
		if (i > 0) {
			for (let j: number = trip.legs[i].lockedStops.length - 1; j >= 0; j--) {
				if (trip.legs[i].lockedStops[j] == 0) {
					trip.legs[i].lockedStops.splice(j, 1);
				};
				if (trip.legs[i].lockedStops[j] == trip.legs[i].clusters.length - 1 && i == trip.legs.length - 1) {
					trip.legs[i].lockedStops.splice(j, 1);
				};
			};
			for (let j: number = trip.legs[i].lockedStops.length - 1; j >= 0; j--) {
				trip.legs[i].lockedStops[j]--;
			};
			lastCluster_ofprevLeg = trip.legs[i].clusters.splice(0, 1)[0];
		};
		if (!trip.legs[i].lockedStops.includes(trip.legs[i].clusters.length - 1)) trip.legs[i].lockedStops.push(trip.legs[i].clusters.length - 1);

		const new_leg: Trip_leg_v2 = {
			clusters: reverseArr(trip.legs[i].clusters),
			lockedStops: reverseLockedArr(trip.legs[i].lockedStops, trip.legs[i].clusters.length)
		};

		new_trip.legs.push(new_leg);
	};

	return new_trip;
};

export function get_genieMatches(stop:Trip_Cluster_v2):Promise<void> {
	return new Promise<void>((resolve,reject) => {
		const campIDs = stop.altStops.map((camp) => camp.camp.campID);
		fetch_genieMatches(campIDs).then(matches => {
			for (let i:number = 0; i < stop.altStops.length; i++) {
				for (let j:number = 0; j < matches.length; j++) {
					if (matches[j].campID == stop.altStops[i].camp.campID) {
						stop.altStops[i].camp.genieMatch = matches[j].genieMatch;
					};
				};
			};
			stop.gotMatchScores = true;
			resolve();
		}).catch(e => {
			reject(e);
		});
	});

};

export function genieWishes_submit_initial(form:HTMLElement):{userInterests_resp:string,whatToDo_resp:string} {
	$(form).find("[use-interests]").prop("disabled",true);
	$(form).find("[whatToDo]").prop("disabled",true);
	$(form).find('button[type="submit"]').addClass("disabled");

	let userInterests_resp:string;
	if ($(form).find("[use-interests]").prop("checked")) {
		userInterests_resp = $(form).find("[userInterests]").val().toString();
	} else {
		userInterests_resp = "";
	};
	let whatToDo_resp:string = $(form).find("[whatToDo]").val().toString();

	if (whatToDo_resp === undefined || whatToDo_resp === null || whatToDo_resp.length == 0) {
		whatToDo_resp = userInterests_resp;
	};

	return {
		userInterests_resp: userInterests_resp,
		whatToDo_resp: whatToDo_resp
	};
};

export function replaceLast(str: string, find: string, replace: string) {
	let lastIndex = str.lastIndexOf(find);

	if (lastIndex === -1) {
		return str;
	}

	let beginning = str.substring(0, lastIndex);
	let ending = str.substring(lastIndex + find.length);

	return beginning + replace + ending;
};

export function getStopTitles_fromLegs(): Array<string> {
	if (window.tripPlannerCurrentTrip === undefined) {
		return []
	};

	let stopNames:Array<string> = [];
	for (let i:number = 0; i < window.tripPlannerCurrentTrip.legs.length; i++) {
		for (let j:number = 0; j < window.tripPlannerCurrentTrip.legs[i].clusters.length;j++) {
			stopNames.push(window.tripPlannerCurrentTrip.legs[i].clusters[j].clusterTitle);
		};
	};

	return stopNames;
};

export function getWarningText_stopNames(section:number,stopTitles:Array<string>): string {
	if ((stopTitles.length < 1) || ((section + 1) >= stopTitles.length) || (section < 0)) {
		return ""
	};
	let warningText:string = " Between " + stopTitles[section] + " & " + stopTitles[section + 1];
	return warningText
};

export function get_camp_addr(campData:Campground_Data) {
	let addr:string = "";
	if (
		campData.camp.street_address != null &&
		campData.camp.street_address != undefined
	) {
		addr += campData.camp.street_address + " ";
	};
	addr += titleCase(campData.camp.city) + ", " + titleCase_withStates(campData.camp.administrative_area_level_1_long);

	return addr;
};